import React from "react";
import Preloader from "../helper/Preloader";

import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ColorInit from "../helper/ColorInit";
import AuthSection from "../components/AuthSection";

const AuthPage = ({ pageTitle }) => {
    return (
        <>
            {/* ColorInit */}
            <ColorInit color={false} />

            {/* Preloader */}
            <Preloader />

            {/* HeaderOne */}
            <HeaderOne />

            {/* Breadcrumb */}
            <Breadcrumb title={pageTitle || "Account"} />

            {/* Main Auth Section */}
            <AuthSection />

            {/* FooterOne */}
            <FooterOne />
            {/* BottomFooter */}
            <BottomFooter />
        </>
    );
};

export default AuthPage;
